import React, { Fragment } from 'react'
import { Visible } from '@leroy-merlin-br/backyard-react'

import { Image } from './styled'

const BannerWebAwards = ({ catalogs }) => {
  const handleRedirect = (event, url) => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: 'openUrl',
          url: url
        })
      )

      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: 'openUrlV2',
          data: {
            url: url
          }
        })
      )

      event.preventDefault()
    }
  }

  const resolveDataTracking = slug =>
    slug === 'l_espace'
      ? 'external-catalog-lespacead'
      : 'external-catalog-leroymerlin'

  return (
    <Fragment>
      {catalogs.map(({ slug, url, banners }) => (
        <a
          key={slug}
          href={url}
          target="_blank"
          onClick={event => handleRedirect(event, url)}
          title="Troque seus pontos por: produtos, viagens e experiências"
          data-tracking={resolveDataTracking(slug)}
        >
          <Visible when={['kilo', 'mega', 'giga', 'tera']}>
            <Image src={banners?.desktop} alt="web-awards-banner" />
          </Visible>

          <Visible when={['untilKilo']}>
            <Image src={banners?.mobile} alt="web-awards-banner-mobile" />
          </Visible>
        </a>
      ))}
    </Fragment>
  )
}

export default BannerWebAwards
